/**
 * Pinterest OAuth callback handler.
 *
 * The browser lands here after the user approves (or denies) permissions on
 * Pinterest. We forward the code + state query params to the backend callback
 * endpoint, which does the token exchange and account upsert, then redirects
 * to /social/accounts?connected=true (or ?error=...).
 *
 * Mirrors TikTokCallback: because the backend callback returns a 302 redirect,
 * we simply build the backend URL with the same query params and navigate to it
 * — the browser follows the redirect chain automatically. The registered
 * Pinterest redirect URI (SOCIAL_PINTEREST_REDIRECT_URI) points here.
 */

import { useEffect } from "react";

export default function PinterestCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code") ?? "";
    const state = params.get("state") ?? "";
    const error = params.get("error") ?? "";

    // Build the backend callback URL preserving all query params.
    const backendParams = new URLSearchParams();
    if (code) backendParams.set("code", code);
    if (state) backendParams.set("state", state);
    if (error) backendParams.set("error", error);

    const backendUrl = `/api/accounts/callback/pinterest?${backendParams.toString()}`;
    window.location.replace(backendUrl);
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-surface-page">
      <div className="text-center">
        <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-4 border-brand-500 border-t-transparent" />
        <h1 className="text-lg font-semibold text-gray-800 dark:text-gray-100">Connecting account...</h1>
        <p className="mt-1 text-sm text-muted">Completing Pinterest authorization</p>
      </div>
    </div>
  );
}
